import { render, staticRenderFns } from "./AmparosCreate.vue?vue&type=template&id=2928cb73"
import script from "./AmparosCreate.vue?vue&type=script&lang=js"
export * from "./AmparosCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports